const isListEditable = (list: HumboList, session: IronSession | null) => {
  const isMine = session?._id === list.user?._id;
  const isEditable = isMine && list.nameId !== 'bucket-list' && list.nameId !== 'visited-places';

  return isEditable;
};

export default isListEditable;
